import { render, staticRenderFns } from "./topicWriting.vue?vue&type=template&id=3ec73efc&scoped=true&"
import script from "./topicWriting.vue?vue&type=script&lang=js&"
export * from "./topicWriting.vue?vue&type=script&lang=js&"
import style0 from "./topicWriting.vue?vue&type=style&index=0&id=3ec73efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec73efc",
  null
  
)

export default component.exports